<div class="sidebar-wrapper d-flex flex-column h-100">
  <aside class="client-sidebar d-flex flex-column h-100 bg-white border-0 border-opacity-50" :class="{ 'onboarding-sidebar': uses_onboarding_system_sidebar, 'mt-5': !uses_onboarding_system_sidebar }">
    <div v-if="uses_onboarding_system_sidebar" class="sidebar-content flex-grow-1 d-flex flex-column">
      <div class="d-flex align-items-center mb-3">
      <div>
        <div class="ms-3 fw-bold text-x lh-sm">
          <img :src="$clientLogo" alt="Logo" class="logo-img" width="170px">
        </div>
      </div>
    </div>

      <section v-if="show_onboarding_journey_selector" class="onboarding-current-journey mb-3">
        <button
          type="button"
          class="onboarding-current-journey-button w-100 d-flex align-items-center gap-3"
          :class="{ 'is-open': current_journey_menu_open }"
          @click="toggle_current_journey_menu"
        >
          <span :class="['onboarding-current-journey-icon', current_onboarding_journey.icon_tone ? `is-${current_onboarding_journey.icon_tone}` : '']">
            <i :class="['bi', current_onboarding_journey.icon]"></i>
          </span>
          <span class="min-w-0 flex-grow-1 text-start">
            <span class="onboarding-current-journey-label d-block text-uppercase">Current Journey</span>
            <span class="onboarding-current-journey-title line-clamp-2 d-block">{{ current_onboarding_journey.label }}</span>
          </span>
          <i :class="['bi', current_journey_menu_open ? 'bi-chevron-up' : 'bi-chevron-down', 'text-muted']"></i>
        </button>

        <div v-if="current_journey_menu_open" class="onboarding-journey-picker shadow-sm">
          <button
            v-for="item in onboarding_journey_picker_items"
            :key="item.id"
            type="button"
            class="onboarding-journey-picker-item w-100 d-flex align-items-center gap-3"
            :class="{ 'is-active': current_onboarding_journey.id === item.id }"
            @click="select_current_journey(item)"
          >
            <span :class="['onboarding-journey-picker-icon', item.icon_tone ? `is-${item.icon_tone}` : '']">
              <i :class="['bi', item.icon]"></i>
            </span>
            <span class="min-w-0 flex-grow-1 text-start">
              <span class="onboarding-journey-picker-title d-block">{{ item.label }}</span>
              <span class="onboarding-journey-picker-meta d-block">{{ item.meta }}</span>
            </span>
            <span v-if="item.count" class="onboarding-sidebar-badge is-neutral">{{ item.count }}</span>
          </button>
        </div>
      </section>

      <nav class="entity-sidebar onboarding-sidebar-nav flex-grow-1">
        <section v-for="group in onboarding_system_groups" :key="group.id" class="mb-4">
          <div class="sidebar-role-block pb-2 px-1">
            <div class="sidebar-role-meta fw-semibold">{{ group.label }}</div>
          </div>

          <ul class="nav flex-column gap-1">
            <li v-for="item in group.items" :key="item.id">
              <router-link
                :to="build_sidebar_route(item)"
                class="nav-link d-flex align-items-center justify-content-between"
                :class="{ active: is_active_route(item.route_name, item.route_query) }"
                @click="handle_sidebar_item_click(item)"
              >
                <span class="d-flex align-items-center gap-3 min-w-0 flex-grow-1">
                  <i :class="['bi', item.icon, 'fs-6', item.icon_tone ? `onboarding-icon-${item.icon_tone}` : '']"></i>
                  <span class="onboarding-sidebar-item-label line-clamp-2">{{ item.label }}</span>
                </span>
                <span
                  v-if="item.count"
                  :class="['onboarding-sidebar-badge', `is-${item.tone || 'neutral'}`]"
                >
                  {{ item.count }}
                </span>
              </router-link>
            </li>
          </ul>
        </section>
      </nav>

      <div class="onboarding-sidebar-user d-flex align-items-center gap-3 mt-auto pt-3">
        <button
          type="button"
          class="d-flex align-items-center gap-3 border-0 bg-transparent w-100 text-start p-0"
          aria-label="View my profile"
          @click="open_profile_modal"
        >
          <span class="config-navbar-initials rounded-circle d-inline-flex align-items-center justify-content-center fw-bold">
            {{ current_user_initials }}
          </span>
          <div class="min-w-0 flex-grow-1">
            <div class="fw-semibold text-black text-truncate">{{ current_user_display_name }}</div>
            <div class="small text-muted text-truncate">{{ current_user_role_label }}</div>
          </div>
        </button>
      </div>
    </div>

    <div v-else-if="uses_case_owner_sidebar" class="sidebar-content flex-grow-1 d-flex flex-column">
      <section class="case-owner-profile-card rounded-4 border p-3">
        <div class="d-flex align-items-start gap-3">
          <div class="case-owner-avatar rounded-circle d-inline-flex align-items-center justify-content-center fw-bold flex-shrink-0">
            {{ case_owner_profile.initials }}
          </div>

          <div class="min-w-0 flex-grow-1">
            <div class="case-owner-name fw-semibold text-truncate">{{ case_owner_profile.name }}</div>
            <div class="case-owner-meta text-uppercase text-truncate">
              {{ sidebar_meta_line || 'USER - WORKSPACE' }}
            </div>
          </div>
        </div>

        <div class="case-owner-metrics row g-0 text-center">
          <div v-for="metric in case_owner_profile.metrics" :key="metric.label" class="col-4">
            <div class="case-owner-metric-value">{{ metric.value }}</div>
            <div class="case-owner-metric-label text-uppercase">{{ metric.label }}</div>
          </div>
        </div>

        <button
          type="button"
          class="case-owner-profile-link d-flex align-items-center justify-content-between text-decoration-none border-0 bg-transparent w-100 px-0 text-start"
          @click="open_case_owner_profile_modal"
        >
          <span>View profile</span>
          <i class="bi bi-chevron-right"></i>
        </button>
      </section>

      <nav class="entity-sidebar case-owner-sidebar-nav mt-4">
        <section class="mb-4">
          <div class="sidebar-role-block pb-2">
            <div class="sidebar-role-meta fw-semibold">MY WORK</div>
          </div>

          <ul class="nav flex-column gap-1">
            <li v-for="item in case_owner_work_items" :key="item.id">
              <router-link
                :to="build_sidebar_route(item)"
                class="nav-link d-flex align-items-center justify-content-between fw-semibold case-owner-nav-link"
                :class="{ active: is_active_route(item.route_name, item.route_query) }"
                @click="close_sidebar"
              >
                <span class="d-flex align-items-center gap-3">
                  <i :class="['bi', item.icon, 'fs-6']"></i>
                  <span>{{ item.label }}</span>
                </span>
                <span v-if="item.count" class="case-owner-count-badge">{{ item.count }}</span>
              </router-link>
            </li>
          </ul>
        </section>

        <section class="mb-4">
          <div class="sidebar-role-block pb-2">
            <div class="sidebar-role-meta fw-semibold">MY ONBOARDING(S) - BY STATUS</div>
          </div>

          <ul class="nav flex-column gap-1">
            <li v-for="item in case_owner_status_items" :key="item.id">
              <router-link
                :to="build_sidebar_route(item)"
                class="nav-link d-flex align-items-center justify-content-between fw-semibold case-owner-status-link"
                :class="{ active: is_active_route(item.route_name, item.route_query) }"
                @click="close_sidebar"
              >
                <span class="d-flex align-items-center gap-3">
                  <span class="case-owner-status-dot rounded-circle" :class="item.dot_class"></span>
                  <span>{{ item.label }}</span>
                </span>
                <span class="case-owner-count-badge">{{ item.count }}</span>
              </router-link>
            </li>
          </ul>
        </section>
      </nav>

      <div class="pt-4 mt-auto border-top">
        <button
          type="button"
          class="ms-2 nav-link nav-item p-0 border-0 bg-transparent"
          @click="sign_out"
        >
          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
        </button>
      </div>

      <CaseOwnerProfileModal
        :visible="show_case_owner_profile_modal"
        :profile="case_owner_profile"
        @close="close_case_owner_profile_modal"
        @edit-profile="handle_case_owner_profile_edit"
      />
    </div>

    <div v-else-if="uses_requestor_sidebar" class="sidebar-content flex-grow-1 d-flex flex-column">
      <nav class="entity-sidebar case-owner-sidebar-nav mt-4">
        <section class="mb-4">
          <div class="sidebar-role-block pb-2">
            <div class="sidebar-role-meta fw-semibold">MY WORK</div>
          </div>

          <ul class="nav flex-column gap-1">
            <li v-for="item in requestor_work_items" :key="item.id">
              <router-link
                :to="build_sidebar_route(item)"
                class="nav-link d-flex align-items-center justify-content-between fw-semibold case-owner-nav-link"
                :class="{ active: is_active_route(item.route_name, item.route_query) }"
                @click="close_sidebar"
              >
                <span class="d-flex align-items-center gap-3">
                  <i :class="['bi', item.icon, 'fs-6']"></i>
                  <span>{{ item.label }}</span>
                </span>
                <span v-if="item.count" class="case-owner-count-badge">{{ item.count }}</span>
              </router-link>
            </li>
          </ul>
        </section>

        <section class="mb-4">
          <div class="sidebar-role-block pb-2">
            <div class="sidebar-role-meta fw-semibold">NEW</div>
          </div>

          <button
            type="button"
            class="requestor-sidebar-new-case-button w-100"
            @click="go_to_requestor_new_case"
          >
            <span class="d-flex align-items-center gap-3">
              <i class="bi bi-plus-lg"></i>
              <span>New onboarding</span>
            </span>
          </button>
        </section>
      </nav>

      <div class="pt-4 mt-auto border-top">
        <button
          type="button"
          class="ms-2 nav-link nav-item p-0 border-0 bg-transparent"
          @click="sign_out"
        >
          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
        </button>
      </div>
    </div>

    <div v-else-if="uses_coordinator_sidebar" class="sidebar-content flex-grow-1 d-flex flex-column">
      <nav class="entity-sidebar case-owner-sidebar-nav mt-4">
        <section class="mb-4">
          <div class="sidebar-role-block pb-2">
            <div class="sidebar-role-meta fw-semibold">COORDINATOR SCOPE</div>
          </div>

          <ul class="nav flex-column gap-1">
            <li v-for="item in coordinator_work_items" :key="item.id">
              <router-link
                :to="build_sidebar_route(item)"
                class="nav-link d-flex align-items-center justify-content-between fw-semibold case-owner-nav-link"
                :class="{ active: is_active_route(item.route_name, item.route_query) }"
                @click="close_sidebar"
              >
                <span class="d-flex align-items-center gap-3">
                  <i :class="['bi', item.icon, 'fs-6']"></i>
                  <span>{{ item.label }}</span>
                </span>
                <span v-if="item.count" class="case-owner-count-badge">{{ item.count }}</span>
              </router-link>
            </li>
          </ul>
        </section>
      </nav>

      <div class="pt-4 mt-auto border-top">
        <button
          type="button"
          class="ms-2 nav-link nav-item p-0 border-0 bg-transparent"
          @click="sign_out"
        >
          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
        </button>
      </div>
    </div>

    <div v-else class="sidebar-content flex-grow-1 d-flex flex-column justify-content-between">
      <nav class="entity-sidebar mt-3">
        <template v-for="group in sidebar_groups" :key="group.id">
          <ul class="nav flex-column gap-1">
            <div class="sidebar-role-block">
              <div class="sidebar-role-meta fw-semibold">{{ sidebar_meta_line || 'USER - WORKSPACE' }}</div>
            </div>
            <li v-for="item in group.items" :key="item.id">
              <router-link
                :to="build_sidebar_route(item)"
                class="nav-link d-flex align-items-center fw-semibold"
                :class="{ active: is_active_route(item.route_name, item.route_query) }"
                @click="close_sidebar"
              >
                <i :class="['bi', item.icon, 'fs-6']"></i>
                <span>{{ item.label }}</span>
              </router-link>
            </li>
          </ul>
        </template>
      </nav>

      <div class="pt-4 mt-4 border-top">
        <button
          type="button"
          class="ms-2 nav-link nav-item p-0 border-0 bg-transparent"
          @click="sign_out"
        >
          <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
        </button>
      </div>
    </div>
  </aside>
</div>

<UserProfileModal
  :visible="show_profile_modal"
  :is-loading="is_loading_profile"
  :is-editing="is_editing_profile"
  :is-saving="is_saving_profile"
  :can-edit="can_edit_profile"
  :error="profile_error"
  :save-error="profile_save_error"
  :profile="profile_modal_data"
  :edit-form="profile_edit_form"
  @close="close_profile_modal"
  @open-edit="open_profile_edit"
  @save="save_profile_edit"
  @update:first-name="profile_edit_form.first_name = $event"
  @update:last-name="profile_edit_form.last_name = $event"
  @update:phone-number="profile_edit_form.phone_number = $event"
  @sanitize-name="sanitize_profile_name"
  @sanitize-phone="sanitize_profile_phone"
/>
